import { isNumber } from 'shared/utils/is-number';
import { WordId } from 'shared/utils/nlp/get-ids-for-words';

export const getWordIndexFromMatch = (
  match: RegExpMatchArray,
  wordIds: WordId[],
): number => {
  const matchIndex = match.index;

  if (!isNumber(matchIndex)) {
    // no match, we return the last word index
    return wordIds.length - 1;
  }

  // get the range of the words to get the matchIndex to match to
  let currentWordIndex = 0;
  const wordStartEndList = wordIds.map(({ word }) => {
    const start = currentWordIndex;
    const end = (currentWordIndex = currentWordIndex + word.length);
    return { start, end };
  });

  const res = wordStartEndList.findIndex(
    ({ start, end }) => matchIndex >= start && matchIndex <= end,
  );

  // if not found, return the last word index
  return res === -1 ? wordIds.length - 1 : res;
};
